import {z} from "../../../../../lib";
import { OperacionCLGFields } from "./fields";
import {CLGDetalleInsertSchema} from "./types";

export const schemaOperacionCLGUpdate = z.object({
    [OperacionCLGFields.CodInstitutionalSales]: z.number(),
    [OperacionCLGFields.FechaAprobacion]: z.date().optional().nullable(),
    [OperacionCLGFields.FechaVencimiento]: z.date()
})

export type OperacionCLGUpdate = z.infer<typeof schemaOperacionCLGUpdate>


export const schemaOperacionCLGInsert = z.object({
    [OperacionCLGFields.CodPais]: z.number(),
    [OperacionCLGFields.CodInstitutionalSales]: z.number(),
    [OperacionCLGFields.FechaAprobacion]: z.date().optional().nullable(),
    [OperacionCLGFields.FechaVencimiento]: z.date(),
    [OperacionCLGFields.BitEnvio]: z.boolean(),
    [OperacionCLGFields.ListaDetalles]: z.array(
        CLGDetalleInsertSchema
    ),

})

export type OperacionCLGInsert = z.infer<typeof schemaOperacionCLGInsert>